const STEPS = [
    {
        title: 'You ask, in plain words',
        text: 'No forms, no codes to remember. “Is my flight on time?” is enough — the assistant picks the tool and fills in the details.'
    },
    {
        title: 'The MCP server translates',
        text: 'It validates the request, calls the right Turkish Airlines system, and hands back structured data plus a ready-made card.'
    },
    {
        title: 'Turkish Airlines answers live',
        text: 'Status, fares, bookings and offers come straight from the operational APIs — the same data the airline app shows.'
    }
];

export function HowItWorks() {
    return (
        <section id="how" className="tkh-section" aria-labelledby="how-title" data-reveal>
            <div className="tkh-wrap">
                <p className="tkh-eyebrow">Flight plan</p>
                <h2 id="how-title" className="tkh-h2">
                    Three legs, one conversation.
                </h2>

                <svg className="tkh-route-svg" viewBox="0 0 1000 120" role="img" aria-label="Route from your assistant through the MCP server to Turkish Airlines">
                    <path id="tkh-route" className="track" d="M 30 90 C 250 90, 300 30, 500 30 S 750 90, 970 90" />
                    <circle className="station" cx="30" cy="90" r="9" />
                    <circle className="station hot" cx="500" cy="30" r="9" />
                    <circle className="station" cx="970" cy="90" r="9" />
                    <g className="plane">
                        <path d="M14 0 L-8 -7 L-12 -5 L-1 0 L-12 5 L-8 7 Z" />
                        <animateMotion dur="9s" repeatCount="indefinite" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="spline" keySplines="0.4 0 0.2 1">
                            <mpath href="#tkh-route" />
                        </animateMotion>
                    </g>
                </svg>

                <div className="tkh-steps">
                    {STEPS.map((s, i) => (
                        <div className="tkh-step" key={s.title} style={{ '--i': i } as React.CSSProperties}>
                            <div className="num">LEG 0{i + 1}</div>
                            <h3>{s.title}</h3>
                            <p>{s.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
